import { Union } from "../fable-library-js.4.19.0/Types.js";
import { bool_type, union_type, list_type, class_type, string_type } from "../fable-library-js.4.19.0/Reflection.js";
import { Color_ofColor, Color_IColor_$reflection, Common_parseOptions, Common_GenericOptions__AddProps_Z4E55E0BD, Common_GenericOptions__AddCaseName_1505, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7 } from "../Fulma.3.0.0/Common.fs.js";
import * as react from "react";
import { keyValueList } from "../fable-library-js.4.19.0/MapUtil.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomClass", "Props", "is-large"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Extensions.Wikiki.Calendar.Option", [], Option, () => [[["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], []]);
}

/**
 * Generate <div class="calendar"></div>
 */
export function calendar(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 2:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            default:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
        }
    }, "calendar"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <div class="calendar-header"></div>
 */
export function header(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "calendar-header"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <div class="calendar-body"></div>
 */
export function body(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "calendar-body"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <div class="calendar-events"></div>
 */
export function events(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "calendar-events"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

export class Date_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomClass", "Props", "is-disabled", "range-start", "calendar-range", "range-end"];
    }
}

export function Date_Option_$reflection() {
    return union_type("Fulma.Extensions.Wikiki.Calendar.Date.Option", [], Date_Option, () => [[["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", bool_type]], [], [], []]);
}

export class Date_Item_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomClass", "Props", "is-today", "is-active"];
    }
}

export function Date_Item_Option_$reflection() {
    return union_type("Fulma.Extensions.Wikiki.Calendar.Date.Item.Option", [], Date_Item_Option, () => [[["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", bool_type]], [["Item", bool_type]]]);
}

/**
 * Generate <div class="calendar-date"></div>
 */
export function Date_date(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 5:
                return Common_GenericOptions__AddCaseName_1505(Common_GenericOptions__AddClass_Z721C83C5(result, "calendar-range"), option);
            case 4:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            case 2:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
            case 1:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddCaseName_1505(Common_GenericOptions__AddClass_Z721C83C5(result, "calendar-range"), option);
        }
    }, "calendar-date"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <button class="date-item"></button>
 */
export function Date_item(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 2:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
            case 1:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "date-item"), (props_1, children_1) => react.createElement("button", keyValueList(props_1, 1), ...children_1), children);
}

export class Event_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomClass", "Props", "Color"];
    }
}

export function Event_Option_$reflection() {
    return union_type("Fulma.Extensions.Wikiki.Calendar.Event.Option", [], Event_Option, () => [[["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", Color_IColor_$reflection()]]]);
}

/**
 * Generate <div class="calendar-event"></div>
 */
export function event(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddClass_Z721C83C5(result, Color_ofColor(option.fields[0]));
        }
    }, "calendar-event"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <div class="calendar-nav"></div>
 */
export function Nav_nav(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "calendar-nav"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <div class="calendar-nav-left"></div>
 */
export function Nav_left(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "calendar-nav-left"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <div class="calendar-nav-right"></div>
 */
export function Nav_right(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "calendar-nav-right"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

//# sourceMappingURL=Calendar.fs.js.map
